module.exports = __webpack_public_path__ + "static/media/marker.24119c8f.png";